// 路由信息，纯JS对象，方便读取路由信息
import Home from './views/Home.vue';
export default {
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
  ],
};
